import { useGLTF } from '@react-three/drei'

export default function HalfTank(props) {
  const { nodes, materials } = useGLTF('/half_tank.glb')
  return (
    <group {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.tank.geometry}
        material={materials['Material.001']}
        position={[0, 0, 0]}></mesh>
    </group>
  )
}

useGLTF.preload('/half_tank.glb')
